'use client';
import { objectEntries, isArray } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const extractTopicData = (topicDefinition)=>{
    if (isArray(topicDefinition)) {
        return topicDefinition;
    }
    return [
        undefined,
        topicDefinition
    ];
};
/**
 * Преобразование объекта в действующие функции отправки аналитики
 * @param definitions { topic1: { method1: (params?: any) => ['event_name', AbstractPayload] } }
 * @param analytics менеджер аналитики
 * @returns объект с методами для отправки событий аналитики
 */ function createTopics(definitions, analytics) {
    return objectEntries(definitions).reduce((functionsMap, [key, topicDefinition])=>{
        const topicKey = key;
        const [topicDefaultValues, topicFunctions] = extractTopicData(topicDefinition);
        const topic = analytics == null ? void 0 : analytics.createTopic((_eventName, payload)=>_extends({}, topicDefaultValues, payload));
        const functionsWithEvents = objectEntries(topicFunctions).reduce((methods, [functionName, callbackFn])=>_extends({}, methods, {
                [functionName]: function(...params) {
                    const [eventName, payload] = callbackFn(...params);
                    topic == null ? void 0 : topic.sendEvent(eventName, payload);
                }
            }), {});
        return _extends({}, functionsMap, {
            [topicKey]: functionsWithEvents
        });
    }, {});
}

export { createTopics };
//# sourceMappingURL=createTopics.js.map
